import { render, staticRenderFns } from "./BirthdaysRequests.vue?vue&type=template&id=09fd2f75&scoped=true&"
import script from "./BirthdaysRequests.vue?vue&type=script&lang=ts&"
export * from "./BirthdaysRequests.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fd2f75",
  null
  
)

export default component.exports